import { createAxiosClient } from "@ntg/component-library/utilities";

export interface IRouteOperationPropertyD365 {
    dataAreaId: string;
    operationId: string;
    operationNumber: number;
    operationPriority: number;
    itemNumber: string;
    routeId: string;
    productionSiteId: string;
    processQuantity: number;
    quantityCostCategoryId: string;
    routeGroupId: string;
    loadPercentage: number;
    resourceQuantity: number;
    setupTime: number;
    queueTimeBefore: number;
    queueTimeAfter: number;
    transitTime: number;
    processTime: number;
    setupCostCategoryId: string;
    routeType: string;
    processCostCategoryId: string;
    costingOperationResourceId: string;
}

export const getRouteOperationPropertiesByRouteD365 = async (
    routeId: string,
    dataAreaId: string,
): Promise<IRouteOperationPropertyD365[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IRouteOperationPropertyD365[]>(
        `/RouteOperation/GetRouteOperationPropertiesByRouteD365`,
        { params: { routeId, dataAreaId } },
    );
    return response.data ?? [];
};
